/**
 * updateResourceList，查找 id 对应的资源列表并更新，直接更新原有的 resource
 * @param {{resource: object, list: any[], categoryId: number}} param0
 */
export default function updateResourceList({
  resource,
  list,
  categoryId
}) {
  if (typeof categoryId !== 'number') {
    console.log('categoryId must be a number')
    throw new Error('categoryId must be a number')
  }

  if (resource[categoryId]) {
    resource[categoryId] = list
  } else {
    throw new Error(`wrong categoryId ${categoryId}`)
  }
}
